import { DATA_CREDITS_HIGH_USAGE_USED_RATIO_THRESHOLD } from "../constants";
import type { QuotaTagCreditsVisualState } from "../types";

export const getQuotaTagCreditsVisualState = (
    remaining: number,
    used: number,
    total: number,
): QuotaTagCreditsVisualState => {
    if (remaining <= 0) {
        return "noCredits";
    }

    if (total > 0 && used / total >= DATA_CREDITS_HIGH_USAGE_USED_RATIO_THRESHOLD) {
        return "highUsage";
    }

    return "default";
};
